import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
    DictionaryItemsModel,
    DictionaryModel,
    ValueTypeModel,
} from "../interfaces/dictionary-model";
import { HttpClient } from "@angular/common/http";
import {
    DICTIONARY,
    PARAMETERS,
    PUBLICATIONS,
    VALUE_TYPES,
} from "../variables/api";

@Injectable({
    providedIn: "root",
})
export class DictionaryService {
    constructor(private readonly http: HttpClient) {}

    getDictionary(): Observable<DictionaryItemsModel> {
        return this.http.get<DictionaryItemsModel>(DICTIONARY);
    }

    getValueTypes(): Observable<ValueTypeModel[]> {
        return this.http.get<ValueTypeModel[]>(VALUE_TYPES);
    }

    /*** @TODO
     * get this list from new table
     * */
    getNodeAttributes(publicationId: string): Observable<{
        section: DictionaryModel[];
        resource: DictionaryModel[];
    }> {
        return this.http.get<{
            section: DictionaryModel[];
            resource: DictionaryModel[];
        }>(`${PUBLICATIONS}/${publicationId}/${PARAMETERS}`);
    }

    addParamToDictionary(
        parametr: DictionaryModel,
    ): Observable<DictionaryItemsModel> {
        return this.http.post<DictionaryItemsModel>(DICTIONARY, parametr);
    }
}
